import { ApiService } from './../_services/api.service';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { MainService } from '../_services/main.service';

@Injectable({
  providedIn: 'root'
})
export class MainGuard implements CanActivate {
  constructor(private main: MainService, private router: Router, private api: ApiService) {
    // console.log("Main Gaurd");
  }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,

  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    let indexAccessToken = state.url.indexOf('access_token=');
    let access_tokenSplitted = state.url.slice(indexAccessToken + 13).split('#https://app.hubspot.com');
    // console.log('access_tokenSplitted',access_tokenSplitted);
    let access_token = access_tokenSplitted[0];
    // console.log("AccessToken=", access_token);
    if (localStorage.getItem('aios')) {
      // console.log('main1');
      return true;
    }
    else if (access_token) {
      // console.log('main2');
      localStorage.setItem('aios', access_token);
      return true;
    }
    else {
      // console.log('main3');
      this.router.navigate(['/', 'auth', 'login']);
      return false;
    }


  }

}
